/* eslint-disable */
/**
 * Neptune TP API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AddOrUpdateTrainingProgramDepartmentCommand,
    AddOrUpdateTrainingProgramDepartmentCommandFromJSON,
    AddOrUpdateTrainingProgramDepartmentCommandToJSON,
    AddOrUpdateTrainingProgramExternalDetailsCommand,
    AddOrUpdateTrainingProgramExternalDetailsCommandFromJSON,
    AddOrUpdateTrainingProgramExternalDetailsCommandToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateTrainingProgramCommand
 */
export interface UpdateTrainingProgramCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateTrainingProgramCommand
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrainingProgramCommand
     */
    description: string;
    /**
     * 
     * @type {AddOrUpdateTrainingProgramExternalDetailsCommand}
     * @memberof UpdateTrainingProgramCommand
     */
    externalDetails?: AddOrUpdateTrainingProgramExternalDetailsCommand;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTrainingProgramCommand
     */
    componentIds?: Array<string> | null;
    /**
     * 
     * @type {Array<AddOrUpdateTrainingProgramDepartmentCommand>}
     * @memberof UpdateTrainingProgramCommand
     */
    departments?: Array<AddOrUpdateTrainingProgramDepartmentCommand> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrainingProgramCommand
     */
    trainingScorecardId?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTrainingProgramCommand
     */
    emailRecipients?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrainingProgramCommand
     */
    sortOrder?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTrainingProgramCommand
     */
    isEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTrainingProgramCommand
     */
    incrementMajorVersion: boolean;
}

export function UpdateTrainingProgramCommandFromJSON(json: any): UpdateTrainingProgramCommand {
    return {
        'name': json['name'],
        'description': json['description'],
        'externalDetails': !exists(json, 'externalDetails') ? undefined : AddOrUpdateTrainingProgramExternalDetailsCommandFromJSON(json['externalDetails']),
        'componentIds': !exists(json, 'componentIds') ? undefined : json['componentIds'],
        'departments': !exists(json, 'departments') ? undefined : (json['departments'] as Array<any>).map(AddOrUpdateTrainingProgramDepartmentCommandFromJSON),
        'trainingScorecardId': !exists(json, 'trainingScorecardId') ? undefined : json['trainingScorecardId'],
        'emailRecipients': !exists(json, 'emailRecipients') ? undefined : json['emailRecipients'],
        'sortOrder': !exists(json, 'sortOrder') ? undefined : json['sortOrder'],
        'isEnabled': json['isEnabled'],
        'incrementMajorVersion': json['incrementMajorVersion'],
    };
}

export function UpdateTrainingProgramCommandToJSON(value?: UpdateTrainingProgramCommand | null): any {
    if (value == undefined) {
        return undefined;
    }
    return {
        'name': value.name,
        'description': value.description,
        'externalDetails': AddOrUpdateTrainingProgramExternalDetailsCommandToJSON(value.externalDetails),
        'componentIds': value.componentIds,
        'departments': value.departments === undefined ? undefined : (value.departments as Array<any>).map(AddOrUpdateTrainingProgramDepartmentCommandToJSON),
        'trainingScorecardId': value.trainingScorecardId,
        'emailRecipients': value.emailRecipients,
        'sortOrder': value.sortOrder,
        'isEnabled': value.isEnabled,
        'incrementMajorVersion': value.incrementMajorVersion,
    };
}


